import { handleError, handleResponse } from "@/utils/functions";

const BASE = "/api/v1/";
const EO = `${BASE}emergency_order/`;

export default (axios) => ({
  login(data) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${BASE}handler/login/`, data)
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },

  search(params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${EO}handler_search/`, { params })
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },

  getFormData(orderId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${EO}handler_form_data/`, { params: orderId ? { order_id: orderId } : {} })
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },

  resolveCustomer(params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${EO}handler_resolve_customer/`, { params })
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },

  pickupGateIn(id) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${EO}${id}/handler_pickup_gate_in/`)
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },

  pickupGateOut(id, data) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${EO}${id}/handler_pickup_gate_out/`, data)
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },

  dropGateIn(id) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${EO}${id}/handler_drop_gate_in/`)
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },

  dropGateOut(id) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${EO}${id}/handler_drop_gate_out/`)
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },

  uploadMilestoneDoc(id, milestone, remarks, document) {
    return new Promise((resolve, reject) => {
      const fd = new FormData();
      fd.append("milestone", milestone);
      if (remarks) fd.append("remarks", remarks);
      if (document) fd.append("document", document);
      axios
        .post(`${EO}${id}/handler_upload_milestone_doc/`, fd)
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },
});
